import React from "react";
import { createRoot } from "react-dom/client";

console.log("react.js is here");

import Actueel from './react-components/pages/Actueel.jsx';
import Activiteiten from './react-components/pages/Activiteiten.jsx';
import ActiviteitenPast from './react-components/pages/ActiviteitenPast.jsx';

const listOfContainers = {
  "#activiteiten-react-container": Activiteiten,
  "#activiteitenpast-react-container": ActiviteitenPast,
  "#actueel-react-container": Actueel,
};

Object.keys(listOfContainers).forEach((containerSelector) => {
  const containerElements = document.querySelectorAll(containerSelector);

  if (containerElements.length > 0) {
    containerElements.forEach((containerElm) => {
      const dataAttributes = containerElm
        .getAttributeNames()
        .filter((attributeName) => attributeName.startsWith("data-"))
        .reduce((result, attributeName) => {
          const key = attributeName.slice(5); // Remove "data-" prefix
          const value = containerElm.getAttribute(attributeName);
          result[key] = value;
          return result;
        }, {});

      const Component = listOfContainers[containerSelector];
      if (Component) {
        // Create props with data attributes
        const props = { data: dataAttributes };

        // Create root and render the component inside it
        const root = createRoot(containerElm);
        root.render(<Component {...props} />);
      } else {
        console.warn(`Component not found for container "${containerSelector}"`);
      }
    });
  }
});
